import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { CourseFormBlock } from "@/modules/learningCenter/features/CourseManagement/components/CourseForm/types";

interface CalloutBlockEditorProps {
  block: CourseFormBlock;
  onContentChange: (content: string) => void;
  onMetadataChange: (metadata: Record<string, unknown> | null) => void;
}

/**
 * Authoring surface for a `callout` block: a short label (stored in
 * `metadata.label`) plus a markdown body (stored in the block `content`).
 */
export function CalloutBlockEditor({
  block,
  onContentChange,
  onMetadataChange,
}: CalloutBlockEditorProps) {
  const rawLabel = block.metadata?.label;
  const label = typeof rawLabel === "string" ? rawLabel : "";

  return (
    <div className="space-y-2">
      <div className="space-y-1">
        <Label htmlFor={`callout-label-${block.id}`}>Label</Label>
        <Input
          id={`callout-label-${block.id}`}
          onChange={(e) =>
            onMetadataChange({
              ...(block.metadata ?? {}),
              label: e.target.value,
            })
          }
          placeholder="e.g. Note, Tip, Warning"
          value={label}
        />
      </div>
      <div className="space-y-1">
        <Label htmlFor={`callout-body-${block.id}`}>Body (markdown)</Label>
        <Textarea
          id={`callout-body-${block.id}`}
          onChange={(e) => onContentChange(e.target.value)}
          placeholder="Write the callout body…"
          rows={3}
          value={block.content ?? ""}
        />
      </div>
    </div>
  );
}
